<template>
    <div>
        <container :active_path="'/invest/paper'" :plate="'投资军团'">
            <div class="base-warp">
                <el-row>
                    <el-col class="base-col" :span="10" :offset="0">
                        <el-form :model="form" ref="form" label-width="80px" :inline="false" size="small">
                            <el-form-item label="早报标题">
                                <el-input v-model="form.title" placeholder="请输入早报标题" maxlength="30"></el-input>
                            </el-form-item>
                            <el-form-item label="日期">
                                <el-date-picker v-model="form.date" type="date" placeholder="选择日期时间" value-format="M月d日">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="内容1">
                                <div class="con-box">
                                    <div class="con-cell" v-for="(item, index) in form.contents1" :key="index">
                                        <div class="con-head">
                                            <el-row>
                                                <el-col :span="18">
                                                    <el-select v-model="item.head" placeholder="请选择栏目" clearable filterable allow-create>
                                                        <el-option v-for="(lm, indd) in heads"
                                                            :key="indd"
                                                            :label="lm"
                                                            :value="lm">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="6">
                                                    <el-button class="del-btn" type="primary" size="small" icon="el-icon-plus" @click="addline('contents1',index)">添加一行</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="con-info">
                                            <el-row class="con-info-cell" v-for="(info, ind) in item.info" :key="ind">
                                                <el-col :span="20" >
                                                    <el-input v-model="info.weight" placeholder="这里写加粗内容" maxlength="30"></el-input>
                                                    <el-input type="textarea" v-model="info.text" placeholder="请输入内容"></el-input>
                                                </el-col>
                                                <el-col :span="4" >
                                                    <el-button class="del-btn" type="danger" size="small" circle icon="el-icon-minus" @click="deleteline('contents1', index, ind)"></el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="内容2">
                                <div class="con-box">
                                    <div class="con-cell" v-for="(item, index) in form.contents2" :key="index">
                                        <div class="con-head">
                                            <el-row>
                                                <el-col :span="18">
                                                    <el-select v-model="item.head" placeholder="请选择栏目" clearable filterable allow-create>
                                                        <el-option v-for="(lm, indd) in heads"
                                                            :key="indd"
                                                            :label="lm"
                                                            :value="lm">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="6">
                                                    <el-button class="del-btn" type="primary" size="small" icon="el-icon-plus" @click="addline('contents2',index)">添加一行</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="con-info">
                                            <el-row class="con-info-cell" v-for="(info, ind) in item.info" :key="ind">
                                                <el-col :span="20" >
                                                    <el-input v-model="info.weight" placeholder="这里写加粗内容" maxlength="30"></el-input>
                                                    <el-input type="textarea" v-model="info.text" placeholder="请输入内容"></el-input>
                                                </el-col>
                                                <el-col :span="4" >
                                                    <el-button class="del-btn" type="danger" size="small" circle icon="el-icon-minus" @click="deleteline('contents2', index, ind)"></el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="save">保存数据</el-button>
                                <el-button type="success" @click="setImage">生成图片</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col class="base-col" :span="7" :offset="0">
                        <div class="example-cell">
                            <div class="item-title">
                                <p class="text">成像效果</p>
                            </div>
                            <div class="img-warp" id="paper">
                                <el-image class="bg-img" :src="require('../../../assets/static/73f52db6024ebd61ef48cf0be476f02.png')" fit="fill" ></el-image>
                                <el-image class="head-img" :src="require('../../../assets/static/805138fc9deb80338ced0af69eb89a6.png')" fit="fill" ></el-image>
                                <p class="text paper-date">{{form.date}}</p>
                                <div class="paper-info">
                                    <div class="paper-box">
                                        <div class="paper-warp">
                                            <div class="paper-cell" v-for="(item, index) in form.contents1" :key="index">
                                                <div class="paper-cell-warp" v-if="item.head">
                                                    <div class="paper-cell-title">
                                                        <p class="cell-title-bg"></p>
                                                        <p class="text">{{item.head}}</p>
                                                    </div>
                                                    <div class="text cell-info">
                                                        <p class="cell-info-list" v-for="(info, ind) in item.info" :key="ind">
                                                            <span class="project">{{info.weight}}</span>
                                                            <span class="text" v-html="info.text"></span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="paper-box">
                                        <div class="paper-warp">
                                            <div class="paper-cell" v-for="(item, index) in form.contents2" :key="index">
                                                <div class="paper-cell-warp" v-if="item.head">
                                                    <div class="paper-cell-title">
                                                        <p class="cell-title-bg"></p>
                                                        <p class="text">{{item.head}}</p>
                                                    </div>
                                                    <div class="text cell-info">
                                                        <p class="cell-info-list" v-for="(info, ind) in item.info" :key="ind">
                                                            <span class="project">{{info.weight}}</span>
                                                            <span class="text" v-html="info.text"></span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <el-image class="foot-img" :src="require('../../../assets/static/679bc4cd0fa5b31d091829b5318c187.png')" fit="fill" ></el-image>
                            </div>
                        </div>
                    </el-col>
                    <el-col class="base-col" :span="7" :offset="0">
                        <div class="example-cell">
                            <div class="item-title">
                                <p class="text">生成图片</p>
                            </div>
                            <canvas id="canvas" class="img-warp"></canvas>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </container>
    </div>
</template>

<script>
import Container from "../../../components/container.vue"
import html2canvas from 'html2canvas'
export default {
    components: { 
        Container,
    },
    data() {
        return {
            form: {
                title: '',
                date: '',
                contents1: [
                    {head: '', info:[{weight: '', text: ''}]},
                    {head: '', info:[{weight: '', text: ''}]},
                ],
                contents2: [
                    {head: '', info:[{weight: '', text: ''}]},
                    {head: '', info:[{weight: '', text: ''}]},
                ],
            },
            id: '',
            heads: ['今日买房', '今日招商', '数读楼市', '热点资讯'],
        }
    },
    mounted () {
        var id = this.$route.query.id;
        this.id = id;
        if (this.id) this.getpaperinfo();
    },
    methods: {
        addline(item, index) {
            var obj = {
                weight: '', 
                text: ''
            };
            this.form[item][index].info.push(obj);
            this.$forceUpdate()
        },
        deleteline(item, index, ind) {
            this.form[item][index].info.splice(ind, 1);
        },
        getpaperinfo() {
            var params = {
                id: this.id
            }
            this.$api.getpapervsid(params).then(
                data=>{
                    data.contents1 = JSON.parse(data.contents1);
                    data.contents2 = JSON.parse(data.contents2);
                    this.form = data;
                }
            )
        },
        save() {
            var params = {
                id: this.id,
                title: this.form.title,
                date: this.form.date,
                contents1: JSON.stringify(this.form.contents1),
                contents2: JSON.stringify(this.form.contents2),
            }
            if (this.id) {
                this.editpaper(params);
                return;
            }
            this.addpaper(params);
        },
        addpaper(params) {
            this.$api.addpaper(params).then(
                data=>{
                    this.$message.success(data);
                }
            )
        },
        editpaper(params) {
            this.$api.editpaper(params).then(
                data=>{
                    this.$message.success(data);
                }
            )
        },
        setImage() {
            let that = this;
            event.preventDefault();
            var canvas2 = document.getElementById("canvas");
            let _canvas = document.getElementById('paper');
            var w = parseInt(window.getComputedStyle(_canvas).width);
            var h = parseInt(window.getComputedStyle(_canvas).height);

            //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了  
            canvas2.width = w * 2;
            canvas2.height = h * 2;
            canvas2.style.width = w + "px";
            canvas2.style.height = h + "px";
            //可以按照自己的需求，对context的参数修改,translate指的是偏移量  
            //  var context = canvas.getContext("2d");  
            //  context.translate(0,0);  
            var context = canvas2.getContext("2d");
            context.scale(2, 2);

            html2canvas(document.getElementById('paper'), {
                canvas: canvas2
            }).then(function (canvas) {
                var blob = that.getBlob(canvas);
                var oMyForm = new FormData();
                var fileName = "mobile" + '.jpg'
                oMyForm.append("file", blob, fileName);
                //				oMyForm.append("fileName", fileName);　　　　
                oMyForm.append("fileType", 'image');
                oMyForm.append("user_id", that.global.company.id)
                // that.uploadFile(that.global.ossservice + "/oss/uploadorgFile", oMyForm).then(res => {
                //     if (res.data.errorCode != '00') {
                //         that.$message.error(res.data.errorMsg);
                //         return;
                //     }
                //     return res.data.sprbody.urlAddress;
                // });
            });
        },
        getBlob (canvas) { //获取blob对象
            var data = canvas.toDataURL("image/jpeg", 1);
            data = data.split(',')[1];
            data = window.atob(data);
            var ia = new Uint8Array(data.length);
            for (var i = 0; i < data.length; i++) {
                ia[i] = data.charCodeAt(i);
            }
            return new Blob([ia], {
                type: "image/jpeg"
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.base-col{
    padding: 0 10px;
    border-right: 1px solid #eee;
    &:last-child{
        border-right: none;
    }
    .example-cell{
        border-bottom: 1px dashed #eee;
        padding-bottom: 10px;
        &:last-child{
            padding-bottom: 0;
            padding-top: 10px;
            border-bottom: none;
        }
        .item-title{
            background: #f7f7f7;
            .text{
                font-size: 14px;
                font-weight: 600;
                line-height: 30px;
            }
        }
        .img-warp{
            width: 410px;
            min-height: 500px;
            position: relative;
            float: left;
            .bg-img{
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 0;
            }
            .head-img{
                margin-top: 10px;
                position: relative;
                z-index: 1;
            }
            .paper-date{
                position: absolute;
                right: 10%;
                transform: translateX(-6px);
                top: 80px;
                z-index: 10;
                color: #fff;
                font-size: 20px;
                font-weight: 600;
            }
        }
    }
}
#paper{
    background: #2b0085;
}
.paper-info{
    position: relative;
    z-index: 10;
    width: 80%;
    margin-left: 10%;
    .paper-box{
        border-radius: 10px;
        overflow: hidden;
        &:first-child{
            background-image: linear-gradient(#e4defb, #a6a2d7 85%, #725fb5);
            padding: 20px 20px 40px;
            margin-left: 26px;
        }
        &:nth-child(2){
            margin-right: 20px;
            padding: 20px;
            background: linear-gradient(#e7e0fc, #d3c8f0);
            margin-top: -30px;
        }
        .paper-warp{
            position: relative;
            .paper-cell{
                margin-bottom: 10px;
                &:last-child{
                    margin-bottom: 0;
                }
                .paper-cell-title{
                    position: relative;
                    margin-bottom: 10px;
                    .cell-title-bg{
                        width: 120px;
                        height: 30px;
                        background: #a748ff;
                        position: absolute;
                        top: 4px;
                        left: 50%;
                        transform: translateX(-56px);
                    }
                    .text{
                        width: 120px;
                        height: 30px;
                        background: #2c0086;
                        color: #fff;
                        font-size: 14px;
                        font-weight: bold;
                        text-align: center;
                        line-height: 30px;
                        margin-left: 50%;
                        transform: translateX(-60px);
                    }
                }
                .cell-info{
                    font-size: 12px;
                    line-height: 22px;
                    white-space: pre-line;
                    .project{
                        font-size: 14px;
                        color: #2c0086;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
.con-box{
    .con-cell{
        margin-bottom: 20px;
        .con-head{
            background: #e4e7ed;
            padding: 4px 0;
            
            .del-btn{
                float: right;
            }
        }
        .con-info{
            .con-info-cell{
                border-bottom: 1px solid #ccc;
                padding: 10px 0;
                .del-btn{
                    float: right;
                    margin-right: 20px;
                    margin-top: 30px;
                }
            }
        }
    }
}


</style>